import Link from 'next/link'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { useEffect, useRef } from 'react'

type BCItem = {
  title: string
  url?: string
}

interface IProps {
  className?: string
  data: BCItem[]
}

const Breadcrumbs = ({ data, className }: IProps) => {
  const scrollContainerRef = useRef<HTMLUListElement>(null)

  useEffect(() => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current
      setTimeout(() => {
        container.scrollLeft = container.scrollWidth
      }, 0)
    }
  }, [data])

  return (
    <div className={`container ${className}`}>
      <nav aria-label='Breadcrumb'>
        <ul
          ref={scrollContainerRef}
          className='flex overflow-x-auto scrollbar-hidden'
        >
          {data.map((item, index) => (
            <li key={index} className='font-normal shrink-0'>
              {item.url ? (
                <Link
                  href={item.url}
                  prefetch={false}
                  className='font-medium hover:underline flex items-center '
                >
                  <span className='capitalize'>{item.title}</span>
                  <ChevronRightIcon width={10} className='mx-4 block' />
                </Link>
              ) : (
                <span>{item.title}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default Breadcrumbs
